export default "__VITE_ASSET__CShQyQ1W__"